
const orderStatusMap = {
    'pause': '暂停中',
    'pauseMessage': '您的订单正处于暂停中，请与设计确认是否需要补充数据',
    'inDesign': '设计中',
    'waitAccept': '已发送',
    'waitDesign': '待设计',
    'waitCheck': '待验收',
    'complete': '已完成',
    'cancel': '已取消',
    'waitRecover': '待恢复设计',
    'waitRedesign': '待重新设计',
    'redesignComplete': '重新设计完成'
};

const ClassTypes = {
    splint: 'splint', // 保持器
    single_crown: 'single_crown', // 单冠
    night_guard: 'night_guard', // 夜磨牙垫
    threeDModel: '3d_model' // 3D模型
}

export {
    orderStatusMap,
    ClassTypes
}